"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Layout = styled_components_1.default.div `
  & > div:first-of-type {
    margin-bottom: ${({ theme }) => theme.spacings.xl};
  }

  & > div:nth-of-type(2) {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  input[type="date"] {
    background-color: ${({ theme }) => theme.colors.whiteBase};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    background-color: ${({ theme }) => theme.colors.silverLighten40};
    flex: 1;
    padding: ${({ theme }) => `${theme.spacings.m} 0 0`};
    overflow: auto;
    width: 100%;
  }
`;
exports.Layout = Layout;
//# sourceMappingURL=Layout.js.map